declare global {
  interface Window {
    GorgiasChat?: {
      open: () => void;
      init: (options?: Record<string, unknown>) => void;
    };
  }
}

/**
 * Handles Gorgias support button click
 * Opens the Gorgias chat widget
 */
export function handleGorgiasSupport(): void {
  try {
    // Check if Gorgias chat widget is available
    if (window.GorgiasChat && typeof window.GorgiasChat.open === 'function') {
      window.GorgiasChat.open();
      return;
    }

    // Fallback: Try to trigger via custom DOM event
    const gorgiasEvent = new CustomEvent('gorgias:chat:open');
    document.dispatchEvent(gorgiasEvent);
  } catch (error) {
    console.warn('[Boost SD] Failed to open Gorgias chat:', error);
  }
}
